// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__326ry","colMin":"styles_colMin__2reM8"};